import type { MRT_ColumnDef } from "mantine-react-table-open";
import { StatusSymbol, StatusSymbolColor } from "../../../Icons/StatusSymbol";
import type { SiteOverviewSite, SiteStatusSite } from "../../site-status-types";

function getRequirementsMBKCreationColumn(): MRT_ColumnDef<
  SiteOverviewSite | SiteStatusSite
> {
  return {
    header: "Voraussetzung Messkonzepterstellung",
    accessorKey: "meteringConceptRequirementsMet",
    Cell: ({ row }) => (
      <StatusSymbol
        color={
          row.original.meteringConceptRequirementsMet
            ? StatusSymbolColor.Green
            : StatusSymbolColor.Red
        }
      />
    ),
    enableGlobalFilter: false,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: [
        { value: "true", label: "Erledigt" },
        { value: "false", label: "Nicht erledigt" }
      ]
    },
    filterFn: (row, _columnId, filterValue) => {
      if (filterValue.length === 0) {
        return true;
      }

      return filterValue.includes(
        String(row.original.meteringConceptRequirementsMet)
      );
    }
  };
}

export { getRequirementsMBKCreationColumn };
